<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">판매등록</span>
            <span class="txt">판매 상품을 결제 등록, 수정, 삭제 할 수 있습니다.</span>
        </div>

        <div class="com-table-top">
            <span class="title">판매 수정</span>
        </div>
        <div class="com-table-wrap">
            <span class="top-title"><span class="title">상품 기본정보</span></span>
            <div class="com-card-input half-type">
                <div class="left-box full">
                    <div class="line">
                        <div class="division">
                            <span class="tit">
                                회원명
                                <span class="imp">*</span>
                            </span>
                            <div class="input-cnt">
                                <input v-model="name" class="w220" disabled type="text" />
                                <button class="com-btn" disabled @click="userPop = true">검색</button>
                            </div>
                        </div>
                        <div class="division">
                            <span class="tit">
                                상품명
                                <span class="imp">*</span>
                            </span>
                            <div class="input-cnt">
                                <!-- <select-form :select-data='["선택", ...itemList]' :select-value="['', ...itemValueList]" class="w220" disabled></select-form> -->
                                <input v-model="title" class="w220" disabled type="text" />
                                <!-- <div class="com-check">
                                    <input type="checkbox" name="check-t1" id="check-t1" v-model="directinput">
                                    <label for="check-t1">직접입력</label>
                                </div>
                                <input type="text" class="w220" :disabled="directinput == false"> -->
                            </div>
                        </div>
                    </div>
                    <div class="line">
                        <div class="division">
                            <span class="tit">판매가</span>
                            <div class="input-cnt">
                                <input
                                    :disabled="directinput == false"
                                    :value="price | numberFormatFilter"
                                    class="w220"
                                    type="text"
                                />
                            </div>
                        </div>
                        <div class="division">
                            <span class="tit">재고수량</span>
                            <div class="input-cnt">
                                <input v-model="stockType" :disabled="directinput == false" class="w220" type="text" />
                            </div>
                        </div>
                        <div class="division">
                            <span class="tit">
                                구매수량
                                <span class="imp">*</span>
                            </span>
                            <div class="input-cnt">
                                <input v-model="number" :disabled="stock <= 0" class="w60 center" type="text" />
                                <span class="txt">개</span>
                            </div>
                        </div>
                        <div class="division">
                            <span class="tit">
                                총 결제금액
                                <span class="imp">*</span>
                            </span>
                            <div class="input-cnt">
                                <input
                                    :disabled="stock <= 0"
                                    :value="total | numberFormatFilter"
                                    class="w220"
                                    type="text"
                                    @input="changeTotalPrice"
                                />
                                <span class="txt">원</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <span class="top-title"><span class="title">상품 결제정보</span></span>

            <div class="com-card-form only-payment">
                <div class="middle-area">
                    <!-- 결제 정보 -->
                    <div class="payment-box">
                        <span class="title">결제정보 - 1</span>
                        <ul class="info-list">
                            <li>
                                <span class="tit">
                                    <span class="imp">*</span>
                                    결제수단 :
                                </span>
                                <div class="center-line">
                                    <div class="flex">
                                        <div class="com-radio">
                                            <input
                                                id="radio-1-1"
                                                v-model="payType"
                                                name="radio-1"
                                                type="radio"
                                                value="C"
                                            />
                                            <label for="radio-1-1">카드</label>
                                        </div>
                                        <div class="com-radio">
                                            <input
                                                id="radio-1-2"
                                                v-model="payType"
                                                name="radio-1"
                                                type="radio"
                                                value="L"
                                            />
                                            <label for="radio-1-2">현금</label>
                                        </div>
                                        <div class="com-radio">
                                            <input
                                                id="radio-1-3"
                                                v-model="payType"
                                                name="radio-1"
                                                type="radio"
                                                value="B"
                                            />
                                            <label for="radio-1-3">계좌이체</label>
                                        </div>
                                        <!-- <div class="com-radio">
                                        <input type="radio" name="radio-1" id="radio-1-4" value="M" v-model="payType">
                                        <label for="radio-1-4">마일리지</label>
                                        </div> -->
                                        <div class="com-radio">
                                            <input
                                                id="radio-1-5"
                                                v-model="payType"
                                                name="radio-1"
                                                type="radio"
                                                value="E"
                                            />
                                            <label for="radio-1-5">기타</label>
                                        </div>
                                    </div>

                                    <div v-show="payType == 'C'" class="card-radio-box">
                                        <div class="com-radio-btn">
                                            <input
                                                id="radio-2-1"
                                                v-model="payCardType"
                                                :checked="payCardType == 'KB'"
                                                name="radio-2"
                                                type="radio"
                                                value="KB"
                                            />
                                            <label for="radio-2-1">KB국민</label>
                                        </div>
                                        <div class="com-radio-btn">
                                            <input
                                                id="radio-2-2"
                                                v-model="payCardType"
                                                :checked="payCardType == 'BC'"
                                                name="radio-2"
                                                type="radio"
                                                value="BC"
                                            />
                                            <label for="radio-2-2">비씨</label>
                                        </div>
                                        <div class="com-radio-btn">
                                            <input
                                                id="radio-2-3"
                                                v-model="payCardType"
                                                :checked="payCardType == 'SM'"
                                                name="radio-2"
                                                type="radio"
                                                value="SM"
                                            />
                                            <label for="radio-2-3">삼성</label>
                                        </div>
                                        <div class="com-radio-btn">
                                            <input
                                                id="radio-2-4"
                                                v-model="payCardType"
                                                :checked="payCardType == 'HY'"
                                                name="radio-2"
                                                type="radio"
                                                value="HY"
                                            />
                                            <label for="radio-2-4">현대</label>
                                        </div>
                                        <div class="com-radio-btn">
                                            <input
                                                id="radio-2-5"
                                                v-model="payCardType"
                                                :checked="payCardType == 'LO'"
                                                name="radio-2"
                                                type="radio"
                                                value="LO"
                                            />
                                            <label for="radio-2-5">롯데</label>
                                        </div>
                                        <div class="com-radio-btn">
                                            <input
                                                id="radio-2-6"
                                                v-model="payCardType"
                                                :checked="payCardType == 'SH'"
                                                name="radio-2"
                                                type="radio"
                                                value="SH"
                                            />
                                            <label for="radio-2-6">신한</label>
                                        </div>
                                        <div class="com-radio-btn">
                                            <input
                                                id="radio-2-7"
                                                v-model="payCardType"
                                                :checked="payCardType == 'WH'"
                                                name="radio-2"
                                                type="radio"
                                                value="WH"
                                            />
                                            <label for="radio-2-7">외한</label>
                                        </div>
                                        <div class="com-radio-btn">
                                            <input
                                                id="radio-2-8"
                                                v-model="payCardType"
                                                :checked="payCardType == 'HA'"
                                                name="radio-2"
                                                type="radio"
                                                value="HA"
                                            />
                                            <label for="radio-2-8">하나</label>
                                        </div>
                                        <div class="com-radio-btn">
                                            <input
                                                id="radio-2-9"
                                                v-model="payCardType"
                                                :checked="payCardType == 'NH'"
                                                name="radio-2"
                                                type="radio"
                                                value="NH"
                                            />
                                            <label for="radio-2-9">NH농협</label>
                                        </div>
                                        <div v-show="isMoreCard" class="com-radio-btn">
                                            <input
                                                id="radio-2-10"
                                                v-model="payCardType"
                                                :checked="payCardType == 'WH'"
                                                name="radio-2"
                                                type="radio"
                                                value="WH"
                                            />
                                            <label for="radio-2-10">우리</label>
                                        </div>
                                        <div v-show="isMoreCard" class="com-radio-btn">
                                            <input
                                                id="radio-2-19"
                                                v-model="payCardType"
                                                :checked="payCardType == 'ET'"
                                                name="radio-2"
                                                type="radio"
                                                value="ET"
                                            />
                                            <label for="radio-2-19">기타</label>
                                        </div>
                                        <button v-show="!isMoreCard" class="more-btn" @click="isMoreCard = true">
                                            + 더보기
                                        </button>
                                    </div>
                                </div>
                            </li>
                            <!-- 결제수단 현금,계좌이체 일시 -->
                            <li v-show="payType == 'L' || payType == 'B'">
                                <span class="tit">영수증발행 :</span>
                                <div class="info">
                                    <div class="flex">
                                        <div class="com-radio">
                                            <input id="radio-money-1" checked name="radio-money" type="radio" />
                                            <label for="radio-money-1">미신청</label>
                                        </div>
                                        <div class="com-radio">
                                            <input id="radio-money-2" name="radio-money" type="radio" />
                                            <label for="radio-money-2">현금영수증</label>
                                        </div>
                                        <div class="com-radio">
                                            <input id="radio-money-3" name="radio-money" type="radio" />
                                            <label for="radio-money-3">세금계산서</label>
                                        </div>
                                    </div>

                                    <div class="input-line">
                                        <input class="w220" placeholder="번호입력" type="text" />
                                    </div>
                                </div>
                            </li>
                            <!-- //결제수단 현금,계좌이체 일시 -->
                            <!-- 결제수단 마일리지 일시 -->
                            <li v-show="payType == 'M'">
                                <span class="tit">보유 마일리지 :</span>
                                <div class="info">
                                    <span class="txt-info">300,000 원</span>
                                    <div class="input-line">
                                        <div class="com-check">
                                            <input
                                                id="check-mileage-1"
                                                name="check-mileage"
                                                type="checkbox"
                                                @change="mileageAllUse"
                                            />
                                            <label for="check-mileage-1">모두사용</label>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li v-show="payType == 'M'">
                                <span class="tit">사용 마일리지 :</span>
                                <div class="info">
                                    <input v-model="mileageUsePrice" class="w220" type="text" />
                                    <span class="txt">원</span>
                                </div>
                            </li>
                            <li v-show="payType == 'M'">
                                <span class="tit">마일리지 잔액 :</span>
                                <div class="info">
                                    <span class="txt-info">{{ mileageBalance }} 원</span>
                                </div>
                            </li>
                            <!-- //결제수단 마일리지 일시 -->
                            <li>
                                <span class="tit">
                                    <span class="imp">*</span>
                                    결제일자 :
                                </span>
                                <div class="info">
                                    <single-calendar
                                        :date="buyDate"
                                        class="w220"
                                        @update="updateDate"
                                    ></single-calendar>
                                </div>
                            </li>
                            <li>
                                <span class="tit">
                                    <span class="imp">*</span>
                                    판매자 :
                                </span>
                                <div class="info">
                                    <select-form
                                        :select-data="['선택', ...staffList]"
                                        :select-value="['', ...staffValueList]"
                                        :selected-value="selectedStaff"
                                        class="w220"
                                        @update:set="(val) => (selectedStaff = val)"
                                    ></select-form>
                                </div>
                            </li>
                            <li>
                                <span class="tit">메모</span>
                                <div class="info">
                                    <textarea v-model="memo" class="com-textarea w1000"></textarea>
                                </div>
                            </li>
                        </ul>
                        <span class="title">마일리지</span>
                        <ul class="info-list">
                            <li class="pl-180">
                                <span class="tit">적립 ({{ mileagePercent }}%) :</span>
                                <div class="info">
                                    <input :value="mileage | numberFormatFilter" type="text" @input="changeMileage" />
                                    <span class="txt">원 적립예정</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div class="bottom-btn">
            <button class="com-btn red" @click="deleteItem">삭제</button>
            <!-- <button class="com-btn">취소</button> -->
            <router-link :to="{ name: 'SalesSell' }" class="com-btn">취소</router-link>
            <button class="com-btn blue" @click="postItem">등록</button>
        </div>

        <!-- 회원 검색 결과 팝업 -->
        <div v-show="userPop" class="layer-pop square-type">
            <div class="view-content">
                <div class="scroll-area com-scroll-y">
                    <span class="sub-title">회원 검색 결과</span>
                    <div class="top-search-area">
                        <div class="right">
                            <input class="w220" placeholder="회원명" type="text" />
                            <button class="com-btn">검색</button>
                        </div>
                    </div>
                    <table class="com-table">
                        <colgroup>
                            <col style="width: 70px" />
                            <col style="width: 120px" />
                            <col style="width: 160px" />
                            <col style="width: 160px" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th></th>
                                <th>회원명</th>
                                <th>연락처</th>
                                <th>생년월일</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <div class="com-radio">
                                        <input id="radio-pop-1" name="radio-pop" type="radio" />
                                        <label for="radio-pop-1"></label>
                                    </div>
                                </td>
                                <td>홍길동</td>
                                <td>017-999-9999</td>
                                <td>1980-01-01</td>
                            </tr>
                            <tr>
                                <td>
                                    <div class="com-radio">
                                        <input id="radio-pop-2" name="radio-pop" type="radio" />
                                        <label for="radio-pop-2"></label>
                                    </div>
                                </td>
                                <td>홍길동</td>
                                <td>017-999-9999</td>
                                <td>1980-01-01</td>
                            </tr>
                            <tr>
                                <td colspan="100">등록된 내용이 없습니다.</td>
                            </tr>
                        </tbody>
                    </table>
                    <b-pagination
                        align="center"
                        aria-controls="my-table"
                        first-class="first"
                        last-class="last"
                        next-class="next"
                        prev-class="prev"
                    ></b-pagination>
                    <div class="bottom-btn">
                        <button class="com-btn" @click="userPop = false">취소</button>
                        <button class="com-btn blue">선택</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';

export default {
    name: 'SalesSellModify',
    props: {},
    computed: {
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
        // total:function(){
        //     return this.price * this.number // 결제금액 계산
        // },
        mileageBalance() {
            return 0; // mileageUsePrice
        },
        mileagePercent() {
            const mileageInfo = this.mileageInfo;
            const payType = this.payType;
            if (payType === 'C' && mileageInfo.tickCardYn) {
                return mileageInfo.ticketCardRatio;
            } else if (payType === 'L' && mileageInfo.tickCashYn) {
                return mileageInfo.ticketCashRatio;
            } else if (payType === 'B' && mileageInfo.ticketBankRatio) {
                return mileageInfo.ticketBankRatio;
            } else if (payType === 'E' && mileageInfo.tickEtcYn) {
                return mileageInfo.ticketEtcRatio;
            }

            return '0.00';
        },
    },
    watch: {
        itemValue(newValue) {
            this.centerProductId = newValue;
            this.onSelectItem();
        },
        selectedStaff(newValue) {
            console.log(newValue);
            this.selectedStaff = newValue;
        },
        number(value) {
            if (value <= this.stock) {
                this.number = value.replace(/[^0-9]/gi, '');
            } else if (value >= this.stock) {
                this.number = this.stock;
            } else {
                this.number = 0;
            }
            this.total = this.number * this.getPureNumber(this.price);
            this.mileage = this.getPureNumber(Math.floor((this.mileagePercent * this.total) / 100));
        },
    },
    data() {
        return {
            centerId: '',
            centerContractId: this.$route.query.contractId,
            centerProductId: this.$route.query.productId,
            name: this.$route.query.name,
            centerCustomerId: '', // 회원 아이디
            isMoreCard: false,
            directinput: false, // 직접입력 버튼
            buyDate: '', // 결제일자 YYYYMMDD
            payType: 'C', // 기본값은 카드 결제.
            payCardType: 'KB', // 기본값은 KB
            payBankType: '',
            percentMileage: '',
            itemList: [], // 상품리스트
            itemValueList: [], // 상품리스트값
            itemValue: '',
            userPop: false, // 회원 검색 팝업

            title: '', // 상품이름
            price: '', // 판매가
            stock: '', // 재고
            stockType: '', // 재고타입
            number: '', // 구매수량
            total: '',

            staffList: [],
            staffValueList: [],
            selectedStaff: '', // 판매스태프
            memo: '',
            mileage: '',
            mileageUsePrice: '', // 마일리지 사용금액
            mileageInfo: {},
        };
    },
    mounted() {
        this.centerId = this.cId; // 센터 Id
        this.load();
        this.onStaffList(); // 스태프가져오기
    },
    methods: {
        // 판매정보 가져오기
        async load() {
            try {
                this.isLoading = true;
                const { data } = await this.getSearchList();
                console.log('1', data);
                const count = await this.getStockCount();
                this.getMileageInfo();
                this.centerCustomerId = data.centerCustomerId;
                this.title = data.centerContractProducts[0].productName;
                this.price =
                    this.centerContractId !== ''
                        ? data.centerContractProducts[0].productOrgPrice
                        : data.centerContractProducts[0].productBuyPrice;
                this.payCardType = data.centerContractBills[0].payCardType;
                this.stock = count.data.stockType == 'U' ? '9999' : count.data.stockTotalCount; // 재고수량값
                this.stockType = count.data.stockType == 'U' ? '무제한' : count.data.stockTotalCount; // 재고수량값
                this.number = data.totalProductCount;
                this.payType = data.centerContractBills[0].payType;
                this.buyDate = data.centerContractBills[0].buyDate;
                // this.buyDate = moment(data.buyDate).format('YYYY-MM-DD');
                this.selectedStaff = data.regStaffId;
                this.memo = data.memo;
                this.mileageUsePrice = data.mileageUsePrice;
                this.mileage = data.totalAddMileage;
                this.total = data.totalBuyPrice;
            } catch (error) {
                console.log(error);
            }
        },
        getSearchList() {
            return api.get(`/admin/api/center/${this.centerId}/uniform/contract/${this.centerContractId}`);
        },
        getStockCount() {
            return api.get(`/admin/api/center/${this.centerId}/uniform/product/${this.centerProductId}`);
        },
        // 수정
        async postItem() {
            try {
                const { data } = await this.onEditItem();
                console.log('수정된 item 값', data);
                alert('수정되었습니다.');
                await this.$router.push({ name: 'SalesSell' });
            } catch (error) {
                console.log(error);
                console.log('실패');
            }
        },
        // 수정 api
        onEditItem() {
            return api.put(`/admin/api/center/${this.centerId}/uniform/contract/${this.centerContractId}`, {
                centerCustomerId: this.centerCustomerId,
                stocKManualYn: true,
                centerProductId: this.centerProductId,
                productName: this.title,
                buyCount: this.number,
                billPrice: this.total,
                billInfo: {
                    debtYn: true,
                    billSeq: 0,
                    buyDate: this.buyDate,
                    billPrice: this.billPrice,
                    payType: this.payType,
                    payCardType: this.payBankType,
                    payBankType: this.payBankType,
                    percentMileage: this.percentMileage,
                },
                saleStaffId: this.selectedStaff, // 현재 적용안되고있음(04.21)
                memo: this.memo, // 현재 적용안되고있음(04.21)
            });
        },
        // 삭제버튼 기능
        async deleteItem() {
            try {
                const { data } = await this.onDeleteItem();
                console.log('삭제된 아이템 값', data);
                alert('삭제되었습니다.');
                await this.$router.push({ name: 'SalesSell' });
            } catch (error) {
                console.log(error);
                alert('삭제할수없습니다.');
            }
        },
        // 삭제
        onDeleteItem() {
            return api.delete(`/admin/api/center/${this.centerId}/uniform/contract/${this.centerContractId}`);
        },
        // 직원목록 가져오기
        async onStaffList() {
            try {
                const { data } = await this.getStaffList();
                data.sort(
                    (
                        a,
                        b // order by 정렬
                    ) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0)
                );
                console.log('직원목록', data);
                data.forEach((g) => {
                    this.staffList.push(g.name);
                    this.staffValueList.push(g.centerStaffId);
                });
                console.log(this.staffList);
            } catch (error) {
                console.log('error');
                console.log(error);
            }
        },
        getStaffList() {
            return api.get(`/admin/api/center/${this.centerId}/staff/teachers/list`);
        },
        updateDate(date) {
            console.log('변동값', date);
            this.buyDate = date;
        },
        mileageAllUse() {
            if (document.getElementById('check-mileage-1').checked) {
                this.mileageUsePrice = 1;
            } else {
                this.mileageUsePrice = 0;
            }
        },
        // 마일리지 설정 정보를 가져오기
        async getMileageInfo() {
            try {
                const { data } = await api.get(`/admin/api/centerMileage/${this.cId}`);
                this.mileageInfo = data;
            } catch (e) {
                console.error(e);
            }
        },
        getNumberFormat(num) {
            if (typeof num !== 'number' || num === undefined || num === '') {
                return num;
            }
            return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        onKeyUpPrice() {
            // 결제 금액 업데이트
            const num = this.getPureNumber(this.price);
            this.price = this.getNumberFormat(num);
        },
        getPureNumber(num) {
            if (typeof num !== 'string' || num === undefined || num === '') {
                return num;
            }
            return parseInt(num.toString().replace(/[,-]/g, ''));
        },
        isNumber(evt) {
            evt = evt || window.event;
            const charCode = evt.which ? evt.which : evt.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        changeTotalPrice(e) {
            this.total = this.getPureNumber(e.target.value);
            this.mileage = Math.floor((this.mileagePercent * this.total) / 100);
            console.log(this.total);
        },
        changeNumber(e) {
            this.number = Number(e.target.value);
            this.total = this.number * this.getPureNumber(this.price);
            this.mileage = this.getPureNumber(Math.floor((this.mileagePercent * this.total) / 100));
            console.log('마일리지', this.mileage);
        },
        changePayType() {
            this.mileage = Math.floor((this.mileagePercent * this.total) / 100);
        },
        changeMileage(e) {
            const num = this.getPureNumber(e.target.value);
            this.mileage = this.getNumberFormat(num);
        },
    },
};
</script>
<style lang="scss"></style>
